"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-destructuring */
var _default = exports["default"] = {
  createCookie: function createCookie(name, value, expires) {
    var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
    var domain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : location.hostname;
    var cookie = "".concat(name, "=").concat(escape(value), ";");
    if (expires) {
      expires = new Date(new Date().getTime() + parseInt(expires, 10) * 1000 * 60 * 60);
      cookie += "expires=".concat(expires.toGMTString(), ";");
    }
    if (path) cookie += "path=".concat(path, ";");
    if (domain) cookie += "domain=".concat(domain, ";");
    cookie += 'secure;samesite=strict';
    document.cookie = cookie;
  },
  getCookie: function getCookie(name) {
    var _document = document,
      cookie = _document.cookie;
    cookie = cookie.split("".concat(name, "="));
    var cookieValue;
    var cookieExists;
    // if the split length is 2 that means cookie exists
    if (cookie.length === 2 && cookie[1]) {
      cookieValue = cookie[1].split(';')[0];
      cookieExists = true;
    } else cookieExists = false;
    return {
      cookieExists: cookieExists,
      cookieValue: cookieValue || null
    };
  },
  deleteCookie: function deleteCookie(cookieName) {
    document.cookie = "".concat(cookieName, "=; Max-Age=0; path=/; domain=").concat(location.hostname);
  }
};